import PropTypes from"prop-types";const propTypes={summary:PropTypes.node||PropTypes.string,characterLimit:PropTypes.number};export default propTypes;